module.exports = __webpack_public_path__ + "img/icon-pse.55245ffd.png";